export default {
  id: 89,
  title: 'Target #89 - Summit',
  url: 'https://cssbattle.dev/play/89',
  colors: ['#191919', '#F9E492', '#4F77FF'],
  solution:
    '<a a><a b><style>body{background:#191919}a{position:fixed}[a]{top:50;left:100;width:200;height:200;border-radius:9in;background:#f9e492}[b]{bottom:0;left:59;width:282;height:141;background:radial-gradient(circle at 50% -10px,#191919,#191919 101px,#4f77ff 101px);clip-path:polygon(0 100%,100% 100%,50% 0)}</style>',
}
